import React, { useState, useEffect } from 'react';
import Loader from '../../../../../presentationals/Loader/Loader.component'
import Popup from '../../../../../presentationals/Popup/Popup.component'
import { getTvrDetailsbyLoanId, SaveTvrDetailsByData } from '../../../AdminActionCreator.component';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { CheckFunction } from '../../../../../../layouts/MainTenantconfig';

const TVRForm = ({ allDetail }) => {
  console.log("allDetail",allDetail)
  const tenant = CheckFunction();

  const [pageType, setPageType] = useState("admin")
  const [userLoanId, setUserLoanId] = useState("")
  const [view, setView] = useState("list")
  const [loader, setLoader] = useState(false)
  const [popup, setPopup] = useState({ show: false, popupStatus: "" })
  const [apiData, setAPiData] = useState({})
  const [formData, setFormData] = useState({
    userName: '', userNameMatch: '',
    //  actualUserName: '',
    fatherName: '', fatherNameMatch: '',
    //  actualFatherName: '',
    phoneConfirmation: '', alternateNumber: '', maritalStatus: '',
    addressType: '', aadhaarAddressMatch: '',
    address: '',
    nearbyLocation: "", nearbyLocationDistance: "",
    coBorrowerName: '', coBorrowerNameMatch: '',
    //  actualCoBorrowerName: '',
    coBorrowerFatherName: '', coBorrowerFatherNameMatch: '',
    relationWithBorrower: '', sameHousehold: '',
    whoWillDrive: '', givenOnRent: "",
    //  otherDriverRelation: '',
    rickshawsOnRent: '', driverName: '', driverPhone: '',
    loanAmount: '', emiAmount: '', emiTenure: '', warrantyPeriod: '',
    tvrPendingSent: false, tvrRemarkSent: false
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const data = {
      "loanId": userLoanId,
      "userName": formData?.userName,
      "nameConfirmation": formData?.userNameMatch,
      "fatherName": formData?.fatherName,
      "fatherNameConfirmation": formData?.fatherNameMatch,
      "phoneNumberConfirmation": formData?.phoneConfirmation,
      "alternateNumber": formData?.alternateNumber,
      "maritalStatus": formData?.maritalStatus,
      "typeOfAddress": formData?.addressType,
      "aadhaarAddressConfirmation": formData?.aadhaarAddressMatch,
      // "distanceFromHouse": "60",
      "nearbyLocation": formData?.nearbyLocation,
      "address": formData?.address,
      "nearbyLocationDistance": formData?.nearbyLocationDistance,
      "coBorrowerName": formData?.coBorrowerName,
      "coBorrowerNameConfirmation": formData?.coBorrowerNameMatch,
      "coBorrowerFatherName": formData?.coBorrowerFatherName,
      "coBorrowerFatherNameConfirmation": formData?.coBorrowerFatherNameMatch,
      "relationWithBorrower": formData?.relationWithBorrower,
      "livingInSameHousehold": formData?.sameHousehold,
      "whoWillDriveVehicle": formData?.whoWillDrive,
      "givenOnRent": formData?.givenOnRent,
      "numberOfERickshawsOnRent": formData?.rickshawsOnRent,
      "nameOfPersonWhoWillDrive": formData?.driverName,
      "phoneNumberOfDriver": formData?.driverPhone,
      "discussedLoanAmount": formData?.loanAmount,
      "discussedEmiAmount": formData?.emiAmount,
      "emiTenureMonths": formData?.emiTenure,
      "batteryWarrantyYears": formData?.warrantyPeriod,
      "tvrPendingMessageSent": formData?.tvrPendingSent,
      "tvrRemarkSent": formData?.tvrRemarkSent
    }
    const obj = { ...data }
    if (apiData?.id) {
      obj.id = apiData?.id
    }

    setLoader(true)
    SaveTvrDetailsByData(obj, callback => {
      setLoader(false)
      if (callback?.message == "success" && callback?.status) {
        setPopup({ show: true, popupStatus: 'Data Saved Successfully!' })
      } else {
        setPopup({ show: true, popupStatus: 'Error Saving Data' })
      }
      removePopup()
    })

  };

  const handleClose = () => {
    setView('list');
  };

  const handleDisabled = () => {
    if (view == "list")
      return true;
    return false
  }

  const closePopup = () => {
    setPopup({ show: false, popupStatus: "" })
  }

  const removePopup = () => {
    setTimeout(() => {
      closePopup()
    }, 5000)
  }


  useEffect(() => {
    const fetchData = async () => {
      const id = await fetchLoanId()
       console.log("id",id)
      setUserLoanId(id)

      setLoader(true)
      getTvrDetailsbyLoanId(id, callback => {
        setLoader(false)
        setAPiData(callback?.data)
        setFormData({
          userName: callback?.data?.userName || '', userNameMatch: callback?.data?.nameConfirmation || '',
          //  actualUserName: '',
          fatherName: callback?.data?.fatherName || '', fatherNameMatch: callback?.data?.fatherNameConfirmation || '',
          //  actualFatherName: '',
          phoneConfirmation: callback?.data?.phoneNumberConfirmation || '', alternateNumber: callback?.data?.alternateNumber || '', maritalStatus: callback?.data?.maritalStatus || '',
          addressType: callback?.data?.typeOfAddress || '', aadhaarAddressMatch: callback?.data?.aadhaarAddressConfirmation || '',
          address: callback?.data?.address || '',
          nearbyLocation: callback?.data?.nearbyLocation || "", nearbyLocationDistance: callback?.data?.nearbyLocationDistance || "",
          coBorrowerName: callback?.data?.coBorrowerName || '', coBorrowerNameMatch: callback?.data?.coBorrowerNameConfirmation || '',
          //  actualCoBorrowerName: '',
          coBorrowerFatherName: callback?.data?.coBorrowerFatherName || '', coBorrowerFatherNameMatch: callback?.data?.coBorrowerFatherNameConfirmation || '',
          relationWithBorrower: callback?.data?.relationWithBorrower || '', sameHousehold: callback?.data?.livingInSameHousehold || '',
          whoWillDrive: callback?.data?.whoWillDriveVehicle || '', givenOnRent: callback?.data?.givenOnRent || "",
          //  otherDriverRelation: '',
          rickshawsOnRent: callback?.data?.numberOfERickshawsOnRent || '', driverName: callback?.data?.nameOfPersonWhoWillDrive || '', driverPhone: callback?.data?.phoneNumberOfDriver || '',
          loanAmount: callback?.data?.discussedLoanAmount || '', emiAmount: callback?.data?.discussedEmiAmount || '', emiTenure: callback?.data?.emiTenureMonths || '', warrantyPeriod: callback?.data?.batteryWarrantyYears || '',
          tvrPendingSent: callback?.data?.tvrPendingMessageSent, tvrRemarkSent: callback?.data?.tvrRemarkSent
        })
      })
    }
    fetchData();
  }, [])


  const fetchLoanId = () => {
    const url = window.location.pathname;
    console.log("url",url)
    if (url == "/adminlogin" || url == "/adminLogin") {
      setPageType("admin")
      return allDetail?.loanId
    } else if (url?.includes('/EVTVR/')) {
      setPageType("link")
      const loanid = url?.split('/EVTVR/')?.[1]
      return loanid
    }

  }



  return (
    <>
      {
        loader ? <Loader /> : ""
      }
      {
        popup?.show ? <Popup popupStatus={popup?.popupStatus} closePopup={closePopup} /> : ""
      }
      
      {
        pageType == "link" ?
          <div className="container-fluid">
            <div className="row">
              <div className="">
                <div style={{ position: 'fixed', top: 0, backgroundColor: '#fff', zIndex: 1000, padding: '10px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', width: '100%', textAlign: 'right' }}>
                  <img src={tenant?.LOGO} style={{ marginTop: '20px', marginLeft: '20px', width: '10%', maxWidth: '103px', float: 'left' }} />
                </div>
              </div>
            </div>
          </div>
          : ""}
      <div style={{ fontFamily: 'system-ui, -apple-system, sans-serif', backgroundColor: '#f5f5f5', borderRadius: '8px', padding: '20px', marginTop: pageType == "link" ? "100px" : "50px" }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto', backgroundColor: 'white', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
          <div style={{ padding: '24px', borderBottom: '1px solid #e5e5e5', position: 'sticky', top: pageType == "link" ? "" : '130px', background: '#ffff', borderTopLeftRadius: '8px', borderTopRightRadius: "8px" }}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>

              <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                <h2 style={{ margin: 0, fontSize: '24px', fontWeight: '600' }}>TVR Details</h2>
              </div>
              {
                // pageType == "link" ? "" :
                  view == "list" ?
                    <div style={{ display: 'flex', gap: '16px', justifyContent: 'center' }}>
                      <button
                        type="button"
                        onClick={() => setView("edit")}
                        style={{ padding: '12px 32px', backgroundColor: '#1e40af', color: 'white', border: 'none', borderRadius: '6px', fontSize: '15px', fontWeight: '500', cursor: 'pointer', transition: 'all 0.2s' }}
                        onMouseOver={(e) => e.target.style.backgroundColor = '#1e3a8a'}
                        onMouseOut={(e) => e.target.style.backgroundColor = '#1e40af'}
                      >
                        Edit
                      </button>
                      {
                        pageType == "link" ? "" :
                      <button
                      type="button"
                      onClick={() => window.open(tenant?.FRONTEND_BASE_URL + "EVTVR/" + userLoanId, "_blank")}
                      style={{ padding: '10px 32px', backgroundColor: '#1e40af', color: 'white', border: 'none', borderRadius: '6px', fontSize: '12px', fontWeight: '500', cursor: 'pointer', transition: 'all 0.2s' }}
                      onMouseOver={(e) => e.target.style.backgroundColor = '#1e3a8a'}
                      onMouseOut={(e) => e.target.style.backgroundColor = '#1e40af'}
                      >
                        <OpenInNewIcon style={{ fontSize: '18px' }} />
                      </button>
                      }
                    </div>
                    :
                    <div style={{ display: 'flex', gap: '16px', justifyContent: 'center' }}>
                      <button
                        type="button"
                        onClick={handleClose}
                        style={{ padding: '12px 32px', backgroundColor: 'white', color: '#374151', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '15px', fontWeight: '500', cursor: 'pointer', transition: 'all 0.2s' }}
                        onMouseOver={(e) => e.target.style.backgroundColor = '#f9fafb'}
                        onMouseOut={(e) => e.target.style.backgroundColor = 'white'}
                      >
                        Close
                      </button>
                      <button
                        type="button"
                        onClick={handleSubmit}
                        style={{ padding: '12px 32px', backgroundColor: '#1e40af', color: 'white', border: 'none', borderRadius: '6px', fontSize: '15px', fontWeight: '500', cursor: 'pointer', transition: 'all 0.2s' }}
                        onMouseOver={(e) => e.target.style.backgroundColor = '#1e3a8a'}
                        onMouseOut={(e) => e.target.style.backgroundColor = '#1e40af'}
                      >
                        Save and Continue
                      </button>
                    </div>
              }
            </div>
          </div>

          <div style={{ padding: '32px', overflowY: 'auto', height: pageType == "link" ? "" : '400px' }}>
            <div style={{ marginBottom: '40px' }}>
              <h3 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '24px', color: '#1f2937' }}>1. Customer Personal Details</h3>

              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px', marginBottom: '20px' }}>
                <div>
                  <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                    User Name <span style={{ color: '#ef4444' }}>*</span>
                  </label>
                  <input
                    type="text"
                    name="userName"
                    value={formData.userName}
                    disabled={handleDisabled()}
                    onChange={handleChange}
                    style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none' }}
                  />
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                    Name Confirmation <span style={{ color: '#ef4444' }}>*</span>
                  </label>
                  <select
                    name="userNameMatch"
                    value={formData.userNameMatch}
                    onChange={handleChange}
                    disabled={handleDisabled()}
                    style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none', backgroundColor: 'white' }}
                  >
                    <option value="">Select</option>
                    <option value="match">Match</option>
                    <option value="not-match">Not-Match</option>
                  </select>
                </div>
                {/* {formData.userNameMatch === 'not-match' && (
                  <div>
                    <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                      Actual Name <span style={{ color: '#ef4444' }}>*</span>
                    </label>
                    <input
                      type="text"
                      name="actualUserName"
                      value={formData.actualUserName}
                      onChange={handleChange}
                      disabled={handleDisabled()}
                      style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none' }}
                    />
                  </div>
                )} */}
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px', marginBottom: '20px' }}>
                <div>
                  <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                    Father Name <span style={{ color: '#ef4444' }}>*</span>
                  </label>
                  <input
                    type="text"
                    name="fatherName"
                    value={formData.fatherName}
                    onChange={handleChange}
                    disabled={handleDisabled()}
                    style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none' }}
                  />
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                    Father Name Confirmation <span style={{ color: '#ef4444' }}>*</span>
                  </label>
                  <select
                    name="fatherNameMatch"
                    value={formData.fatherNameMatch}
                    onChange={handleChange}
                    disabled={handleDisabled()}
                    style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none', backgroundColor: 'white' }}
                  >
                    <option value="">Select</option>
                    <option value="match">Match</option>
                    <option value="not-match">Not-Match</option>
                  </select>
                </div>
                {formData.fatherNameMatch === 'not-match' && (
                  <div>
                    <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                      Actual Father Name <span style={{ color: '#ef4444' }}>*</span>
                    </label>
                    <input
                      type="text"
                      name="actualFatherName"
                      value={formData.actualFatherName}
                      onChange={handleChange}
                      disabled={handleDisabled()}
                      style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none' }}
                    />
                  </div>
                )}
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px' }}>
                <div>
                  <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                    Phone Number Confirmation <span style={{ color: '#ef4444' }}>*</span>
                  </label>
                  <select
                    name="phoneConfirmation"
                    value={formData.phoneConfirmation}
                    onChange={handleChange}
                    disabled={handleDisabled()}
                    style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none', backgroundColor: 'white' }}
                  >
                    <option value="">Select</option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </select>
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                    Alternate Number
                  </label>
                  <input
                    type="tel"
                    name="alternateNumber"
                    value={formData.alternateNumber}
                    onChange={handleChange}
                    disabled={handleDisabled()}
                    style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none' }}
                  />
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                    Marital Status <span style={{ color: '#ef4444' }}>*</span>
                  </label>
                  <select
                    name="maritalStatus"
                    value={formData.maritalStatus}
                    onChange={handleChange} disabled={handleDisabled()}
                    style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none', backgroundColor: 'white' }}
                  >
                    <option value="">Select</option>
                    <option value="married">Married</option>
                    <option value="unmarried">Un-Married</option>
                    <option value="divorced">Divorced</option>
                    <option value="widow">Widow/Widower</option>
                  </select>
                </div>
              </div>
            </div>

            <div style={{ marginBottom: '40px' }}>
              <h3 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '24px', color: '#1f2937' }}>2. Address Confirmation</h3>

              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px', marginBottom: '20px' }}>
                <div>
                  <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                    Type of Address <span style={{ color: '#ef4444' }}>*</span>
                  </label>
                  <select
                    name="addressType"
                    value={formData.addressType}
                    onChange={handleChange} disabled={handleDisabled()}
                    style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none', backgroundColor: 'white' }}
                  >
                    <option value="">Select</option>
                    <option value="owned">Owned</option>
                    <option value="rented">Rented</option>
                    <option value="with-relative">With Relative</option>
                    <option value="other">Other</option>
                  </select>
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                    Aadhaar Address Confirmation <span style={{ color: '#ef4444' }}>*</span>
                  </label>
                  <select
                    name="aadhaarAddressMatch"
                    value={formData.aadhaarAddressMatch}
                    onChange={handleChange} disabled={handleDisabled()}
                    style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none', backgroundColor: 'white' }}
                  >
                    <option value="">Select</option>
                    <option value="same">Same as Aadhaar Address</option>
                    <option value="not-same">Not Same as Aadhaar</option>
                  </select>
                </div>
              </div>

              {formData.aadhaarAddressMatch === 'not-same' && (
                <>
                  <div style={{ marginBottom: '20px' }}>
                    <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                      Current Address <span style={{ color: '#ef4444' }}>*</span>
                    </label>
                    <input
                      type="text"
                      name="address"
                      value={formData.address}
                      onChange={handleChange} disabled={handleDisabled()}
                      style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none' }}
                    />
                  </div>
                  {/* <div style={{ marginBottom: '20px' }}>
                    <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                      Current Address Line 2
                    </label>
                    <input
                      type="text"
                      name="currentAddressLine2"
                      value={formData.currentAddressLine2}
                      onChange={handleChange} disabled={handleDisabled()}
                      style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none' }}
                    />
                  </div>
                  <div style={{ marginBottom: '20px' }}>
                    <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                      Current Address Line 3
                    </label>
                    <input
                      type="text"
                      name="currentAddressLine3"
                      value={formData.currentAddressLine3}
                      onChange={handleChange} disabled={handleDisabled()}
                      style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none' }}
                    />
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px', marginBottom: '20px' }}>
                    <div>
                      <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                        Area <span style={{ color: '#ef4444' }}>*</span>
                      </label>
                      <input
                        type="text"
                        name="area"
                        value={formData.area}
                        onChange={handleChange} disabled={handleDisabled()}
                        style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none' }}
                      />
                    </div>
                    <div>
                      <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                        Pin Code <span style={{ color: '#ef4444' }}>*</span>
                      </label>
                      <input
                        type="text"
                        name="pinCode"
                        value={formData.pinCode}
                        onChange={handleChange} disabled={handleDisabled()}
                        style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none' }}
                      />
                    </div>
                    <div>
                      <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                        Landmark
                      </label>
                      <input
                        type="text"
                        name="landmark"
                        value={formData.landmark}
                        onChange={handleChange} disabled={handleDisabled()}
                        style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none' }}
                      />
                    </div>
                  </div> */}
                </>
              )}

              <h4 style={{ fontSize: '16px', fontWeight: '600', marginTop: '24px', marginBottom: '16px', color: '#374151' }}>
                Distance from House to Nearby Location (meters, up to 100 max)
              </h4>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px', marginBottom: '20px' }}>
                <div>
                  <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#374151' }}>Nearby Location</label>
                  <select
                    name="nearbyLocation"
                    value={formData.nearbyLocation}
                    onChange={handleChange} disabled={handleDisabled()}
                    style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none', backgroundColor: 'white' }}
                  >
                    <option value="">Select</option>
                    <option value="School">School</option>
                    <option value="Temple">Temple</option>
                    <option value="Mosque">Mosque</option>
                    <option value="Gurudwara">Gurudwara</option>
                    <option value="Hospital">Hospital</option>
                    <option value="Police Station">Police Station</option>
                    <option value="Government Office">Government Office</option>
                  </select>
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#374151' }}>Nearby Location Distance</label>
                  <input
                    type="number"
                    name="nearbyLocationDistance"
                    value={formData.nearbyLocationDistance}
                    onChange={handleChange} disabled={handleDisabled()}
                    style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none' }}
                  />
                </div>


              </div>

            </div>

            <div style={{ marginBottom: '40px' }}>
              <h3 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '8px', color: '#1f2937' }}>3. Co-Borrower Personal Details</h3>
              <p style={{ fontSize: '13px', color: '#6b7280', marginBottom: '24px' }}>(To be filled only if there is a co-borrower in the case)</p>

              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px', marginBottom: '20px' }}>
                <div>
                  <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                    Co-Borrower Name
                  </label>
                  <input
                    type="text"
                    name="coBorrowerName"
                    value={formData.coBorrowerName}
                    onChange={handleChange} disabled={handleDisabled()}
                    style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none' }}
                  />
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                    Name Confirmation
                  </label>
                  <select
                    name="coBorrowerNameMatch"
                    value={formData.coBorrowerNameMatch}
                    onChange={handleChange} disabled={handleDisabled()}
                    style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none', backgroundColor: 'white' }}
                  >
                    <option value="">Select</option>
                    <option value="match">Match</option>
                    <option value="not-match">Not-Match</option>
                  </select>
                </div>
                {/* {formData.coBorrowerNameMatch === 'not-match' && (
                  <div>
                    <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                      Actual Name
                    </label>
                    <input
                      type="text"
                      name="actualCoBorrowerName"
                      value={formData.actualCoBorrowerName}
                      onChange={handleChange} disabled={handleDisabled()}
                      style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none' }}
                    />
                  </div>
                )} */}
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px', marginBottom: '20px' }}>
                <div>
                  <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                    Father's Name
                  </label>
                  <input
                    type="text"
                    name="coBorrowerFatherName"
                    value={formData.coBorrowerFatherName}
                    onChange={handleChange} disabled={handleDisabled()}
                    style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none' }}
                  />
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                    Father Name Confirmation
                  </label>
                  <select
                    name="coBorrowerFatherNameMatch"
                    value={formData.coBorrowerFatherNameMatch}
                    onChange={handleChange} disabled={handleDisabled()}
                    style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none', backgroundColor: 'white' }}
                  >
                    <option value="">Select</option>
                    <option value="match">Match</option>
                    <option value="not-match">Not-Match</option>
                  </select>
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                    Relation with Borrower
                  </label>
                  <input
                    type="text"
                    name="relationWithBorrower"
                    value={formData.relationWithBorrower}
                    onChange={handleChange} disabled={handleDisabled()}
                    style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none' }}
                  />
                </div>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px' }}>
                <div>
                  <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                    Living in Same Household as Borrower
                  </label>
                  <select
                    name="sameHousehold"
                    value={formData.sameHousehold}
                    onChange={handleChange} disabled={handleDisabled()}
                    style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none', backgroundColor: 'white' }}
                  >
                    <option value="">Select</option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </select>
                </div>
              </div>
            </div>

            <div style={{ marginBottom: '40px' }}>
              <h3 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '24px', color: '#1f2937' }}>4. Loan Purpose</h3>

              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px', marginBottom: '20px' }}>
                <div>
                  <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                    Who Will Drive the Vehicle <span style={{ color: '#ef4444' }}>*</span>
                  </label>
                  <select
                    name="whoWillDrive"
                    value={formData.whoWillDrive}
                    onChange={handleChange} disabled={handleDisabled()}
                    style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none', backgroundColor: 'white' }}
                  >
                    <option value="">Select</option>
                    <option value="self">Self</option>
                    <option value="landlord">Landlord</option>
                    <option value="landlord-son">Landlord's Son</option>
                    <option value="friend">Friend</option>
                    <option value="wife">Wife</option>
                    <option value="father">Father</option>
                    <option value="mother">Mother</option>
                    <option value="son">Son</option>
                    <option value="brother">Brother</option>
                    <option value="sister">Sister</option>
                    <option value="uncle">Uncle (Paternal)</option>
                    <option value="daughter">Daughter</option>
                    <option value="other">Other</option>
                  </select>
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                    Will be Given on Rent <span style={{ color: '#ef4444' }}>*</span>
                  </label>
                  <select
                    name="givenOnRent"
                    value={formData.givenOnRent}
                    onChange={handleChange} disabled={handleDisabled()}
                    style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none', backgroundColor: 'white' }}
                  >
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>

                  </select>
                </div>
                {/* {formData.whoWillDrive === 'other' && (
                  <div>
                    <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                      Specify Relation <span style={{ color: '#ef4444' }}>*</span>
                    </label>
                    <input
                      type="text"
                      name="otherDriverRelation"
                      value={formData.otherDriverRelation}
                      onChange={handleChange} disabled={handleDisabled()}
                      style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none' }}
                    />
                  </div>
                )} */}
              </div>
              {
                formData?.givenOnRent == "Yes" ?
                  <>
                    <h4 style={{ fontSize: '16px', fontWeight: '600', marginTop: '24px', marginBottom: '16px', color: '#374151' }}>
                      If Given on Rent
                    </h4>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px' }}>
                      <div>
                        <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                          Currently Number of E-Rickshaws on Rent
                        </label>
                        <input
                          type="number"
                          name="rickshawsOnRent"
                          value={formData.rickshawsOnRent}
                          onChange={handleChange} disabled={handleDisabled()}
                          min="0"
                          style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none' }}
                        />
                      </div>
                      <div>
                        <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                          Name of Person Who Will Drive
                        </label>
                        <input
                          type="text"
                          name="driverName"
                          value={formData.driverName}
                          onChange={handleChange} disabled={handleDisabled()}
                          style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none' }}
                        />
                      </div>
                      <div>
                        <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                          Phone Number of Driver
                        </label>
                        <input
                          type="tel"
                          name="driverPhone"
                          value={formData.driverPhone}
                          onChange={handleChange} disabled={handleDisabled()}
                          style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none' }}
                        />
                      </div>
                    </div>
                  </>
                  : ""}
            </div>

            <div style={{ marginBottom: '40px' }}>
              <h3 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '24px', color: '#1f2937' }}>5. Loan Details</h3>

              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px' }}>
                <div>
                  <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                    Discussed Loan Amount <span style={{ color: '#ef4444' }}>*</span>
                  </label>
                  <input
                    type="number"
                    name="loanAmount"
                    value={formData.loanAmount}
                    onChange={handleChange} disabled={handleDisabled()}
                    style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none' }}
                  />
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                    Discussed EMI Amount <span style={{ color: '#ef4444' }}>*</span>
                  </label>
                  <input
                    type="number"
                    name="emiAmount"
                    value={formData.emiAmount}
                    onChange={handleChange} disabled={handleDisabled()}
                    style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none' }}
                  />
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                    EMI Tenure (in Months) <span style={{ color: '#ef4444' }}>*</span>
                  </label>
                  <input
                    type="number"
                    name="emiTenure"
                    value={formData.emiTenure}
                    onChange={handleChange} disabled={handleDisabled()}
                    style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none' }}
                  />
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                    Battery Warranty Period (in Years) <span style={{ color: '#ef4444' }}>*</span>
                  </label>
                  <input
                    type="number"
                    name="warrantyPeriod"
                    value={formData.warrantyPeriod}
                    onChange={handleChange} disabled={handleDisabled()}
                    style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none' }}
                  />
                </div>
              </div>
            </div>

            <div style={{ marginBottom: '40px' }}>
              <h3 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '24px', color: '#1f2937' }}>6. WhatsApp Notifications</h3>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: '12px', cursor: 'pointer' }}>
                  <input
                    type="checkbox"
                    name="tvrPendingSent"
                    checked={formData.tvrPendingSent}
                    onChange={handleChange} disabled={handleDisabled()}
                    style={{ width: '18px', height: '18px', cursor: 'pointer' }}
                  />
                  <span style={{ fontSize: '14px', color: '#374151' }}>TVR Pending Message Sent</span>
                </label>
                <label style={{ display: 'flex', alignItems: 'center', gap: '12px', cursor: 'pointer' }}>
                  <input
                    type="checkbox"
                    name="tvrRemarkSent"
                    checked={formData.tvrRemarkSent}
                    onChange={handleChange} disabled={handleDisabled()}
                    style={{ width: '18px', height: '18px', cursor: 'pointer' }}
                  />
                  <span style={{ fontSize: '14px', color: '#374151' }}>TVR Remark Sent</span>
                </label>
              </div>
            </div>


          </div>
        </div>
      </div>
    </>
  );
};

export default TVRForm

